module.exports = __webpack_public_path__ + "static/media/wedo1.1516dc26.svg";